import { createSlice } from '@reduxjs/toolkit';
import { initialState, NAME } from './settings.consts';

const slice = createSlice({
  name: NAME,
  initialState,
  reducers: {
    toggleDarkMode(state) {
      state.darkMode = !state.darkMode;
    },
    toggleSidebarCollapse(state) {
      state.sidebarIsCollapased = !state.sidebarIsCollapased;
    },
    toggleIsBlocked(state) {
      state.isBlocked = !state.isBlocked;
    },
  },
});

export const { reducer } = slice;
export const { toggleDarkMode, toggleIsBlocked } = slice.actions;
